import { render, staticRenderFns } from "./element-select.vue?vue&type=template&id=0d9956f4&scoped=true"
import script from "./element-select.vue?vue&type=script&lang=js"
export * from "./element-select.vue?vue&type=script&lang=js"
import style0 from "./element-select.vue?vue&type=style&index=0&id=0d9956f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9956f4",
  null
  
)

export default component.exports